import React from "react";

function Navbar() {
	return (
		<div className="header-container center-div">
			<div className="logo-container">
				<img src="../spacex-logo.png" alt="spacex-logo" />
			</div>
		</div>
	);
}

export default Navbar;
